var path = '/pages/contacts/views/contact-genderize-modal.html';
var html = "<button class=\"close\" ng-click=\"vm.close()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n        <h2>Gender Check</h2>\n</div>\n<div class=\"modal-body\">\n    <p>Which contacts would you like to update gender for?</p>\n    <div class=\"btn-group\">\n        <button class=\"btn-regular\" ng-click=\"vm.all()\" >All selected contacts</button>\n        <button class=\"btn-regular\" ng-click=\"vm.unknown()\" >If gender unknown</button>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contacts/views/contact-genderize-modal.html
// module id = 2228
// module chunks = 1